import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {FeaturesIndexOld} from './_variants/FeaturesIndexOld'
import {FeaturesIndexU24} from './_variants/FeaturesIndexU24'

export function FeaturesIndex() {
  const {siteUniverse24} = useRoutePayload<{siteUniverse24: boolean}>()
  if (siteUniverse24) {
    return <FeaturesIndexU24 />
  } else {
    return <FeaturesIndexOld />
  }
}

try{ FeaturesIndex.displayName ||= 'FeaturesIndex' } catch {}